import { useState, useEffect } from 'react';

// 断点配置
const breakpoints = {
  xs: 0,
  sm: 576,
  md: 768,
  lg: 992,
  xl: 1200,
  xxl: 1600
};

const getBreakpointByWidth = (width) => {
  let breakpoint = 'xs';
  if (width >= breakpoints.xxl) {
    breakpoint = 'xxl';
  } else if (width >= breakpoints.xl) {
    breakpoint = 'xl';
  } else if (width >= breakpoints.lg) {
    breakpoint = 'lg';
  } else if (width >= breakpoints.md) {
    breakpoint = 'md';
  } else if (width >= breakpoints.sm) {
    breakpoint = 'sm';
  }
  return breakpoint;
};

const getViewportSize = () => {
  const vv = window.visualViewport;
  const width = vv?.width != null ? Math.round(vv.width) : window.innerWidth;
  const height = vv?.height != null ? Math.round(vv.height) : window.innerHeight;
  return { width, height };
};

const isMobileUserAgent = () => {
  const ua = String(navigator.userAgent || '');
  if (/Android|iPhone|iPod|Windows Phone/i.test(ua)) return true;
  const isIpad = /iPad/i.test(ua);
  const isTouchMac = /Macintosh/i.test(ua) && Number(navigator.maxTouchPoints || 0) > 1;
  return isIpad || isTouchMac;
};

export const useBreakpoint = () => {
  const uaMobile = isMobileUserAgent();
  const [screenSize, setScreenSize] = useState(() => ({
    ...getViewportSize(),
  }));

  const [currentBreakpoint, setCurrentBreakpoint] = useState(() => getBreakpointByWidth(getViewportSize().width));

  useEffect(() => {
    const handleResize = () => {
      const { width, height } = getViewportSize();
      
      setScreenSize({ width, height });

      // 确定当前断点
      setCurrentBreakpoint(getBreakpointByWidth(width));
    };

    // 初始化
    handleResize();

    // 添加事件监听
    window.addEventListener('resize', handleResize);
    window.visualViewport?.addEventListener('resize', handleResize);
    window.visualViewport?.addEventListener('scroll', handleResize);

    // 清理事件监听
    return () => {
      window.removeEventListener('resize', handleResize);
      window.visualViewport?.removeEventListener('resize', handleResize);
      window.visualViewport?.removeEventListener('scroll', handleResize);
    };
  }, []);

  const width = Number(screenSize?.width || 0);
  const isMobileByWidth = width > 0 && width < breakpoints.md;
  const isTabletByWidth = width >= breakpoints.md && width < breakpoints.lg;
  const isDesktopByWidth = width >= breakpoints.lg;

  const isMobile = isMobileByWidth || (uaMobile && !isDesktopByWidth);
  const isTablet = !isMobile && isTabletByWidth;
  const isDesktop = !isMobile && isDesktopByWidth;

  return {
    screenSize,
    currentBreakpoint,
    isMobile,
    isTablet,
    isDesktop,
    isSmallScreen: isMobile || isTablet,
  };
};
